import React from 'react';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useApiGet } from '../../utils/httpClientTs';
import { listStorefrontOrders } from '../../endpoints/chapterSupplies';

const formatPrice = (v: number) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
    v || 0
  );

const StorefrontOrders: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useApiGet(
    ['chapter-supplies-storefront-orders'],
    () => listStorefrontOrders({ limit: 100, offset: 0 })
  );

  return (
    <Box sx={{ p: 3 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/chapter-supplies/storefront')}
        sx={{ mb: 2 }}
      >
        Back to Storefront
      </Button>
      <Typography variant="h4" sx={{ mb: 2 }}>
        My Orders
      </Typography>
      {isLoading && <Typography>Loading orders...</Typography>}
      {error && <Typography color="error">Unable to load orders.</Typography>}
      {!isLoading && !error && (data?.data?.length || 0) === 0 && (
        <Typography color="text.secondary">No orders yet.</Typography>
      )}
      <Stack spacing={2}>
        {data?.data?.map((order) => (
          <Card key={order.order_id}>
            <CardActionArea
              onClick={() =>
                navigate(
                  `/chapter-supplies/storefront/orders/${order.order_id}`
                )
              }
            >
              <CardContent>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  justifyContent="space-between"
                  alignItems={{ xs: 'flex-start', sm: 'center' }}
                  spacing={1}
                >
                  <Box>
                    <Typography variant="subtitle1">
                      Order {order.order_id}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {new Date(order.placed_at).toLocaleString()}
                    </Typography>
                  </Box>
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                  >
                    <Chip
                      size="small"
                      label={order.order_status_name || order.order_status_id}
                    />
                    <Typography variant="h6" color="primary.main">
                      {formatPrice(order.total)}
                    </Typography>
                  </Stack>
                </Stack>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default StorefrontOrders;
